// clientSwiper

let clientSwiper;

// function initClientSwiper() {
//   if (clientSwiper) clientSwiper.destroy(true, true);

//   clientSwiper = new Swiper(".clientSwiper", {
//     slidesPerView: 5,
//     loop: true,
//     loopAdditionalSlides: 10, // 🧠 Prevents flicker
//     centeredSlides: false,
//     spaceBetween: 0,
//     speed: 2000,
//     grabCursor: true,
//     autoplay: {
//       delay: 0,
//       enabled: true,
//       // disableOnInteraction: false,
//     },
//     allowTouchMove: false, // ❌ Disable touch/swipe
//   simulateTouch: false,  // ❌ Prevent click-drag simulation
//   slideToClickedSlide: false, // ❌ Disable slide on click
//     breakpoints: {
//       1024: {
//         slidesPerView: 3,
//       },
//       480: {
//         slidesPerView: 2,
//       }
//     }
//   });
// }

function initClientSwiper() {
  if (clientSwiper) clientSwiper.destroy(true, true);

  clientSwiper = new Swiper(".clientSwiper", {
    autoplay: true,
    spaceBetween: 0,
    centeredSlides: false,
    slidesPerView: "auto",
    // slidesPerView: "5",
    loop: true,
    speed: 4000,
    allowTouchMove: false, // ❌ Disable touch/swipe
    simulateTouch: false, // ❌ Prevent click-drag simulation
    slideToClickedSlide: false, // ❌ Disable slide on click
    breakpoints: {
      1024: {
        // slidesPerView: 3,
        slidesPerView: "auto",
      },
      480: {
        // slidesPerView: 2,
        slidesPerView: "auto",
      },
    },
  });
}

// Initialize on load
initClientSwiper();

// Debounce resize event to avoid performance issues
let resizeTimeout;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initClientSwiper();
  }, 300); // Adjust debounce delay as needed
});

// farmers-slider
$(document).ready(function () {
  // Swiper with fade effect
  new Swiper(".farmers-slider", {
    loop: true,
    effect: "fade", // This changes the transition to fade
    fadeEffect: {
      crossFade: true, // This enables cross-fade between slides
    },
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0, // Set to 0 for fade effect
    breakpoints: {
      1920: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1028: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });
});

// testimonial-slider
$(document).ready(function () {
  // Swiper with fade effect
  new Swiper(".testimonial-slider", {
    loop: true,
    // effect: 'fade', // This changes the transition to fade
    // fadeEffect: {
    //     crossFade: true // This enables cross-fade between slides
    // },
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 30, // Set to 0 for fade effect
    breakpoints: {
      1920: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });

  
  // console.log("code is working")
  //   new Swiper(".banner-slider", {
  //     loop: true,
  //     slidesPerView: 1,

  //     navigation: {
  //       nextEl: ".swiper-button-next-1",
  //       prevEl: ".swiper-button-prev-1",
  //     },

  //   });
  

});


// videoThumbnail

function playVideo() {
  const thumbnail = document.getElementById("videoThumbnail");
  const video = document.getElementById("video");

  thumbnail.style.display = "none"; // hide thumbnail
  video.style.display = "block"; // show video
  video.play(); // autoplay
}

// copper-custom-dropdown start

$(document).ready(function () {
  // Toggle dropdown
  // $('.copper-custom-dropdown .dropdown-toggle').click(function (e) {
  //   e.stopPropagation();

  //   const $toggle = $(this);
  //   const $menu = $toggle.next('.dropdown-menu');

  //   if ($menu.is(':visible')) {
  //     $menu.hide();
  //     $toggle.removeClass('active');
  //   } else {
  //     $('.dropdown-menu').hide();
  //     $('.dropdown-toggle').removeClass('active');

  //     $menu.show();
  //     $toggle.addClass('active');
  //   }
  // });

  $(document).on(
    "click",
    ".copper-custom-dropdown .dropdown-toggle",
    function (e) {
      e.stopPropagation();

      const $toggle = $(this);
      const $menu = $toggle.next(".dropdown-menu");

      if ($menu.is(":visible")) {
        $menu.hide();
        $toggle.removeClass("active");
      } else {
        $(".dropdown-menu").hide();
        $(".dropdown-toggle").removeClass("active");

        $menu.show();
        $toggle.addClass("active");
      }
    }
  );

  // Select dropdown item
  // $('.copper-custom-dropdown .dropdown-menu li').click(function () {
  //   const selectedText = $(this).text();
  //   const $dropdown = $(this).closest('.copper-custom-dropdown');

  //   // Remove active from all items and add to clicked one
  //   $dropdown.find('li').removeClass('active');
  //   $(this).addClass('active');

  //   $dropdown.find('.dropdown-toggle').text(selectedText).removeClass('active');
  //   $dropdown.find('.dropdown-menu').hide();
  // });

  // V2
  //   $(document).on('click', '.copper-custom-dropdown .dropdown-menu li', function () {
  //   const selectedText = $(this).text();
  //   const $dropdown = $(this).closest('.copper-custom-dropdown');

  //   // Remove 'active' class from all items and add it to the clicked one
  //   $dropdown.find('li').removeClass('active');
  //   $(this).addClass('active');

  //   // Update toggle button label and close the menu
  //   $dropdown.find('.dropdown-toggle').text(selectedText).removeClass('active');
  //   $dropdown.find('.dropdown-menu').hide();
  // });

  $(document).on(
    "click",
    ".copper-custom-dropdown .dropdown-menu li",
    function () {
      const selectedText = $(this).text();
      const selectedValue = $(this).data("value");
      const $dropdown = $(this).closest(".copper-custom-dropdown");

      const $select = $("#SortBy");

      // Visual updates
      $dropdown.find("li").removeClass("active");
      $(this).addClass("active");

      $(".dropdown-toggle").text(selectedText).removeClass("active");
      // $dropdown.find('.dropdown-toggle').text(selectedText).removeClass('active');
      $dropdown.find(".dropdown-menu").hide();

      // Update <select> and trigger real events
      if ($select.length) {
        $select.val(selectedValue);

        // Human-like interaction for Dawn theme
        $select[0].dispatchEvent(new Event("input", { bubbles: true }));
        $select[0].dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  );

  // Hide dropdown when clicking outside
  $(document).click(function () {
    $(".copper-custom-dropdown .dropdown-menu").hide();
    $(".copper-custom-dropdown .dropdown-toggle").removeClass("active");
  });
});

//

const headers = document.querySelectorAll(".accordion-header");

headers.forEach((header) => {
  header.addEventListener("click", () => {
    const content = header.nextElementSibling;
    const isOpen = content.style.display === "block";

    // Close all
    document
      .querySelectorAll(".accordion-content")
      .forEach((c) => (c.style.display = "none"));
    document
      .querySelectorAll(".accordion-header")
      .forEach((h) => h.classList.remove("active"));

    // Open this one if not already open
    if (!isOpen) {
      content.style.display = "block";
      header.classList.add("active");
    }
  });
});

//  slider bar toggle

// document.querySelectorAll('.copper-facets-wrapper .has-sub .toggle-heading').forEach(toggle => {
//   toggle.addEventListener('click', () => {
//     const parent = toggle.parentElement;
//     const allParents = document.querySelectorAll('.copper-facets-wrapper .has-sub');

//     // Sabhi se 'open' class hata do
//     allParents.forEach(p => {
//       if (p !== parent) {
//         p.classList.remove('open');
//       }
//     });

//     // Current parent me toggle karo
//     parent.classList.toggle('open');
//   });
// });

// document.querySelectorAll('.copper-facets-wrapper .has-sub span.btn').forEach(toggle => {
//   toggle.addEventListener('click', () => {
//     const parent = toggle.parentElement;
//     const allParents = document.querySelectorAll('.copper-facets-wrapper .has-sub');

//     // Sabhi se 'open' class hata do
//     allParents.forEach(p => {
//       if (p !== parent) {
//         p.classList.remove('open');
//       }
//     });

//     // Current parent me toggle karo
//     parent.classList.toggle('open');
//   });
// });

$(document).on(
  "click",
  ".copper-facets-wrapper .has-sub span.btn",
  function () {
    var parent = $(this).closest(".has-sub");
    var allParents = $(".copper-facets-wrapper .has-sub");

    // Remove 'open' class from all other parents
    allParents.not(parent).removeClass("open");

    // Toggle 'open' class on the current parent
    parent.toggleClass("open");
  }
);
